import { render, staticRenderFns } from "./auth-callback.component.html?vue&type=template&id=61c644d8&"
import script from "./auth-callback.component.ts?vue&type=script&lang=js&"
export * from "./auth-callback.component.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports